import { put, takeLatest, fetch, takeEvery, apply } from '@ers/helpers/redux/sagaEffects';
import ApiFactory from '@ers/api/ApiFactory';
import { sendEvent } from '@ers/root/App.actions';
import { eventTypes } from '@ers/data/';
import AppApi from '@ers/root/App.api';
import { addSuccess, addError } from '@ers/pages/toasts/toasts.actions';
import { ActionTypes, fetchApplicationsCompleted, fetchFileCompleted, fetchEditUrlCompleted, archiveUpdated, resetApplications, fetchArchivedCountCompleted, fetchFileError } from './Home.actions';


function* fetchApplications(api, action) {
    const { archived } = action.payload;
    const response = yield fetch(api, archived ? api.fetchArchivedApplications : api.fetchApplications);
    if (!response.error) {
        const finalAction = fetchApplicationsCompleted({ payload: { applications: response.data, archived } });
        yield put(finalAction);
    }
}
function* fetchFile(api, action) {
    const { key } = action.payload;
    const [applicationId, fileId] = key.split('_');
    const response = yield fetch(api, api.fetchFile, [applicationId, fileId]);
    if (!response.error) {
        const actionCompleted = fetchFileCompleted(applicationId, fileId, response.data.blob);
        yield put(actionCompleted);
    } else {
        yield put(addError('Wystąpił błąd, nie można pobrać pliku.', 5));
        yield put(fetchFileError(key));
    }
}
function* fetchEditUrl(api, action) {
    const { key } = action.payload;
    const response = yield fetch(api, api.fetchEditUrl, [key]);
    if (!response.error) {
        const actionCompleted = fetchEditUrlCompleted(key, response.data);
        yield put(actionCompleted);
    }
}

function* archive(api, action) {
    const { applicationId, archived } = action.payload;
    if (!archived) {
        yield put(sendEvent(eventTypes.archive, { }));
    }
    const response = yield fetch(api, api.archive, [applicationId, archived]);
    if (!response.error) {
        const actionCompleted = archiveUpdated();
        yield put(addSuccess(
            !archived
                ? 'Zarchiwizowano aplikację'
                : 'Dodano ponownie do listy aplikacji',
            5
        ));
        yield put(actionCompleted);
        yield put(resetApplications());
    }
}

function* fetchArchivedCount(api) {
    const response = yield fetch(api, api.fetchArchivedCount);
    if (!response.error) {
        const actionCompleted = fetchArchivedCountCompleted(response.data);
        yield put(actionCompleted);
    }
}

export default function* homeSaga() {
    const apiFactory = new ApiFactory();
    const api = yield apply(apiFactory, apiFactory.create);
    const appApi = new AppApi(api);
    yield takeLatest(ActionTypes.fetchApplications, fetchApplications, appApi);
    yield takeEvery(ActionTypes.fetchFile, fetchFile, appApi);
    yield takeEvery(ActionTypes.fetchEditUrl, fetchEditUrl, appApi);
    yield takeEvery(ActionTypes.archive, archive, appApi);
    yield takeEvery(ActionTypes.fetchArchivedCount, fetchArchivedCount, appApi);
}
